import { CATEGORY_MANAGEMENT } from "api/ApiPath";
import { ListBaseApiResponseModel } from "app/based/baseApiModel/baseApiResponseModel/ListBaseApiResponseModel";
import client from "api/client";
import { CategoryRequestModel } from "./model/CategoryRequestModel";
import { CategoryResponseModel } from "./model/CategoryResponseModel";
import { injectable } from "tsyringe";

export interface ICategoryRepository {
  getList(
    params: CategoryRequestModel
  ): Promise<ListBaseApiResponseModel<CategoryResponseModel>>;
  getListV2(
    params: CategoryRequestModel
  ): Promise<ListBaseApiResponseModel<CategoryResponseModel>>;
}

@injectable()
export class CategoryRepositoryImpl implements ICategoryRepository {
  async getList(
    params: CategoryRequestModel
  ): Promise<ListBaseApiResponseModel<CategoryResponseModel>> {
    return client?.get(CATEGORY_MANAGEMENT.LIST, params);
  }

  async getListV2(
    params: CategoryRequestModel
  ): Promise<ListBaseApiResponseModel<CategoryResponseModel>> {
    return client?.get(CATEGORY_MANAGEMENT.LIST_V2, params);
  }
}
